<template>
  <span class="prefix w-2 h-2 rounded-full border border-gray-200" :style="`background-color: ${prefixGenerate}`">
  </span>
</template>
<script>
export default {
  props: {
    status: {
      required: false
    },
    statusList: {
      type: Array,
      required: true
    },
    index: {
      type: String,
      required: false,
      default: 'color'
    }
  },
  computed: {
    prefixGenerate() {
      return this.index != '' ?
        this.statusList.find((i) => i.id == this.status) != undefined
          ? this.statusList.find((i) => i.id == this.status)[this.index].code
          : ""
        : this.statusList.find((i) => i.id == this.status) != undefined
          ? this.statusList.find((i) => i.id == this.status).code
          : ""
    },
  },
};
</script>
